import React from 'react';
import type { QuoteSummary } from '../types/quote.types';
import { getProductCurrency } from '@/features/products/services/productCurrency';
import type { PricedBasket } from '../types/basketPricing.types';
import { useQuoteSummaryLines } from '../hooks/useQuoteSummaryLines';
import { useQuoteSummaryPayment } from '../hooks/useQuoteSummaryPayment';
import { OptionalExtrasPanel } from './QuoteSummaryCard/OptionalExtrasPanel';
import { QuoteCustomerPanel } from './QuoteSummaryCard/QuoteCustomerPanel';
import { QuoteDealerPanel } from './QuoteSummaryCard/QuoteDealerPanel';
import { QuoteSummaryHeader } from './QuoteSummaryCard/QuoteSummaryHeader';
import { QuoteVehiclePanel } from './QuoteSummaryCard/QuoteVehiclePanel';
import { ServicesPanel } from './QuoteSummaryCard/ServicesPanel';

type QuoteSummaryCardProps = Omit<QuoteSummary, 'estimated_start_date' | 'total_cost' | 'pricingVersion'> & {
    pricing: PricedBasket | undefined;
};

export const QuoteSummaryCard: React.FC<QuoteSummaryCardProps> = ({
    dealer,
    vehicle,
    product,
    services,
    addOns,
    paymentSelection,
    customer,
    pricing,
}) => {
    const currency = getProductCurrency(product);
    const payment = useQuoteSummaryPayment(paymentSelection, product.schedulingMethods, currency);
    const lines = useQuoteSummaryLines(services, addOns, pricing, currency);

    return (
        <div className="space-y-6">
            <QuoteSummaryHeader totals={lines.totals} payment={payment} />
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                <QuoteCustomerPanel customer={customer} />
                <QuoteVehiclePanel vehicle={vehicle} />
            </div>
            <ServicesPanel product={product} lines={lines.serviceLines} currency={currency} />
            <OptionalExtrasPanel lines={lines.addOnLines} />
            <QuoteDealerPanel dealer={dealer} />
        </div>
    );
};
